"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchTermsList;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _item = _interopRequireDefault(require("./item"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _headlineLockup = require("@site/pattern-library-core/headline-lockup");
var _siteSearchContext = require("../site-search-context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SuggestedSearchesContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SuggestedSearchesContainer",
  class: "pl-sdl6oz"
});

/**
 * Search Banner Component
 * @module SuggestedSearches
 *
 * @param {Object} props React props
 * @param {String} props.suggestedSearchesHeadline Suggestions Headline
 * @param {Array} props.suggestedSearches Array of Suggestions
 * @returns {React.ReactElement} Search Banner Component
 * @public
 */
function SearchTermsList({
  step = 'initial'
}) {
  const {
    suggestedList,
    suggestedSearchesHeadline,
    trackingCustomProperties: customProps
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  const stepMap = {
    initial: 'popular_terms',
    suggestions: 'autocomplete',
    noresults: 'search_suggestions'
  };
  const terms = suggestedList?.map((title, ix) => (0, _patternLibraryUtils.applySnakeCase)([title, step, ix].join('_')));
  const trackingEid = stepMap[step];
  const trackingCustomProperties = {
    ...customProps,
    [trackingEid]: terms.join('¬')
  };
  return /*#__PURE__*/_react.default.createElement(SuggestedSearchesContainer, {
    "data-cy": "suggested-searches"
  }, /*#__PURE__*/_react.default.createElement(_headlineLockup.HeadlineString, {
    heading: suggestedSearchesHeadline,
    headlineSize: 'h6',
    headingDataCy: 'terms-list-headline'
  }), suggestedList?.map((title, index) => /*#__PURE__*/_react.default.createElement(_item.default, {
    key: index,
    title: title,
    trackingEid: trackingEid,
    trackingCustomProperties: {
      ...trackingCustomProperties,
      suggestion_rank: index
    }
  })));
}
SearchTermsList.propTypes = {
  step: _propTypes.default.string
};